import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import IriusRiskCredentialsForm from "./IriusRiskCredentialsForm";
import IriusRiskConfigListing from "./IriusRiskConfigListing";

export default function IriusRiskPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={IriusRiskCredentialsForm}
      PullConfigListingView={IriusRiskConfigListing}
    />
  );
}
